import get from 'lodash.get';

export type ACHFormType = {
    accountType?: string;
    ownershipType?: string;
    routingNumber?: string;
    accountNumber?: string;
    firstNameOnAccount?: string;
    lastNameOnAccount?: string;
    businessNameOnAccount?: string;
};

export type FormKeys = keyof ACHFormType;

type Valid = {
    isValid: boolean;
    fieldErrors: ACHFormType;
};

const achValidate = (values: ACHFormType): Valid => {
    let isValid = false;

    const fieldErrors: ACHFormType = Object.keys(values).reduce(
        (acc: ACHFormType, curr: string): ACHFormType => {
            let error = '';
            const currValue = get(values, curr);
            if (currValue.length < 1) {
                switch (curr) {
                    case 'accountNumber':
                        error = 'Please enter a valid account number';
                        break;
                    case 'firstNameOnAccount':
                        error = 'Please enter the first name on account';
                        break;
                    case 'lastNameOnAccount':
                        error = 'Please enter the last name on account';
                        break;
                    case 'businessNameOnAccount':
                        error = 'Please enter the business name on account';
                        break;
                    default:
                        error = 'This is a required field';
                }
            }
            if (curr === 'routingNumber' && currValue.length < 9) {
                error = 'Please enter a valid routing number';
            }
            acc = {
                ...acc,
                [curr]: error,
            };
            return acc as ACHFormType;
        },
        {}
    );

    const routingAndAccountValid = !fieldErrors.routingNumber && !fieldErrors.accountNumber;

    // for personal accounts
    if (
        routingAndAccountValid &&
        values.ownershipType === 'personal' &&
        !fieldErrors.firstNameOnAccount &&
        !fieldErrors.lastNameOnAccount
    ) {
        isValid = true;
    }

    // for business accounts
    if (
        routingAndAccountValid &&
        values.ownershipType === 'business' &&
        !fieldErrors.businessNameOnAccount
    ) {
        isValid = true;
    }

    return {
        isValid,
        fieldErrors,
    };
};

export default achValidate;
